import * as d3 from "d3";
import JSON5 from "json5";

const parse_tracking_date = d3.utcParse("%Y%m%d");

const days_mapping = {
    "30days": 30,
    "90days": 90,
    "180days": 180,
    "1year": 365,
    "all_time": Infinity,
};

function sum_tracking_view(dataset) {
    return dataset.reduce((total, item) => {
        const tracking = Number(item.tracking);
        return total + (Number.isFinite(tracking) ? tracking : 0);
    }, 0);
}

export async function combine_tracking_over_time(time_scale = "all_time") {
    const rows = await d3.csv(
        "dataset/tracking_data/tracking_view.csv"
    );

    const combined_data = rows
        .map(row => {
            const date = parse_tracking_date(String(row.date));
            const dataset = JSON5.parse(row.dataset);

            return {
                date,
                value: sum_tracking_view(dataset),
            };
        })
        .filter(row => {
            return row.date instanceof Date
                && !Number.isNaN(row.date.getTime())
                && Number.isFinite(row.value);
        })
        .sort((a, b) => a.date - b.date);

    const number_of_days = days_mapping[time_scale];

    // if (number_of_days === undefined) {
    //     throw new Error(`Unknown tracking time scale: ${time_scale}`);
    // }

    if (number_of_days === Infinity) {
        return combined_data;
    }

    return combined_data.slice(-number_of_days);
}